import axios from 'axios';
import qs from 'qs';
import Jsona from 'jsona';

var url = process.env.VUE_APP_API_BASE_URL;
var jsona = new Jsona();

function listSettings(params) {
    var options = {
        params: params || {},
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/settings', options)
        .then(function(response) {
            return {
                data: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function getSetting(key) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/settings/' + key, options)
        .then(function(response) {
            return jsona.deserialize(response.data);
        });
}

function updateSetting(key, payload) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.put(url + '/settings/' + key, payload, options)
        .then(function(response) {
            return jsona.deserialize(response.data);
        });
}

function resetSetting(key) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/settings/' + key + '/reset', {}, options)
        .then(function(response) {
            return jsona.deserialize(response.data);
        });
}

function getSettingOverrides(key) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/settings/' + key + '/overrides', options)
        .then(function(response) {
            return jsona.deserialize(response.data);
        });
}

function createOverride(payload) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/settings/overrides', payload, options)
        .then(function(response) {
            return jsona.deserialize(response.data);
        });
}

function deleteOverride(overrideId) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(url + '/settings/overrides/' + overrideId, options)
        .then(function(response) {
            return response.data;
        });
}

function initializeDefaults() {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(url + '/settings/initialize', {}, options)
        .then(function(response) {
            return response.data;
        });
}

function getDefaultSettings() {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(url + '/settings/defaults', options)
        .then(function(response) {
            return response.data;
        });
}

export default {
    listSettings: listSettings,
    getSetting: getSetting,
    updateSetting: updateSetting,
    resetSetting: resetSetting,
    getSettingOverrides: getSettingOverrides,
    createOverride: createOverride,
    deleteOverride: deleteOverride,
    initializeDefaults: initializeDefaults,
    getDefaultSettings: getDefaultSettings
};